
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Icon from '@/ui-kit/components/icon';
import { IconType } from '@/ui-kit/components/icon/enums';
import {
  StyleColorSchemeType,
  StyleSizeType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import {
  DateFormatHelper,
  DateOptionsBuilder,
  DayFormats,
  MonthFormats,
  YearFormats,
} from '@/ui-kit/helpers/DateFormatHelper';

const DATE_FORMAT = new DateOptionsBuilder()
  .addYearFormat(YearFormats.Numeric)
  .addMonthFormat(MonthFormats.Long)
  .addDayFormat(DayFormats.TwoDigit)
  .build();
const SECOND_IN_MILLISECONDS = 1000;
const SECONDS_IN_AN_HOUR = 3600;
const HOURS_IN_A_DAY = 24;
const WARNING_THRESHOLD_IN_DAYS = 2;

export default {
  name: 'BuilderPendingInfo',
  components: {
    Typography,
    Icon,
  },
  props: {
    closingDate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      TypographyType,
      IconType,
      StyleColorSchemeType,
      StyleSizeType,
      StyleFontWeightType,
    };
  },
  computed: {
    isClosingDateWithinTwoDaysOrPassed() {
      const currentDate = new Date();
      const closingDate = new Date(this.closingDate);
      const timeDiffInMilliseconds = closingDate.getTime() - currentDate.getTime();
      const daysDiff = timeDiffInMilliseconds
        / (SECOND_IN_MILLISECONDS * SECONDS_IN_AN_HOUR * HOURS_IN_A_DAY);

      return daysDiff <= WARNING_THRESHOLD_IN_DAYS;
    },
    contentColor() {
      return this.isClosingDateWithinTwoDaysOrPassed
        ? StyleColorSchemeType.Danger
        : StyleColorSchemeType.SuccessDark;
    },
    backgroundColor() {
      return this.isClosingDateWithinTwoDaysOrPassed
        ? this.$style.backgroundColorDanger
        : this.$style.backgroundColorSuccess;
    },
    dateText() {
      return DateFormatHelper.format(this.closingDate, DATE_FORMAT);
    },
  },
};
